// extracted by mini-css-extract-plugin
module.exports = {"container":"icon_container__36RbL","icon":"icon_icon__2sgQT","dark":"icon_dark__2L9c4","brass":"icon_brass__fDQTx","light":"icon_light__3G_cj"};